const updateNumberValue = (value: string, func: (newValue: string) => void) => {
  const isValidNumber = /^-?\d*\.?\d*$/.test(value);
  const newValue = isValidNumber ? value : '';
  if (newValue === '' || !isNaN(Number(newValue))) {
    func(newValue);
  }
}

export default updateNumberValue;
